module.exports = "/_next/static/images/3D-c8eab485de5e869ecd8cf3c998817701.png";